import {
	API_GET_ALL_DOCUMENT_TYPE,
	API_GET_DOCUMENT_TYPE_BY_NAME,
	API_ADMIN_GET_ALL_DOCUMENT_TYPE,
	API_ADMIN_GET_DOCUMENT_TYPE,
	ADMIN_INIT_NEW_DOCUMENT_TYPE,
	ADMIN_RESET_FOCUS_DOCUMENT_TYPE,
	API_ADMIN_POST_DOCUMENT_TYPE,
	API_ADMIN_PATCH_DOCUMENT_TYPE,
	API_ADMIN_DELETE_DOCUMENT_TYPE,
} from "actions/documentType";

export function getAllDocumentTypes() {
	return {
		type: API_GET_ALL_DOCUMENT_TYPE,
		payload: {
			request: {
				url: `/documentTypes`,
			},
		},
	};
}

export function getDocumentTypeByName(name) {
	return {
		type: API_GET_DOCUMENT_TYPE_BY_NAME,
		payload: {
			request: {
				url: `/documentTypes/${name}`,
			},
		},
	};
}

export function adminGetAllDocumentTypes() {
	return {
		type: API_ADMIN_GET_ALL_DOCUMENT_TYPE,
		payload: {
			request: {
				url: `/admin/documentTypes`,
			},
		},
	};
}

export function adminGetDocumentType(documentType) {
	return {
		type: API_ADMIN_GET_DOCUMENT_TYPE,
		payload: {
			request: {
				url: `/admin/documentTypes/${documentType.id}`,
			},
		},
	};
}

export function adminPostDocumentType(documentType) {
	return {
		type: API_ADMIN_POST_DOCUMENT_TYPE,
		payload: {
			request: {
				url: `/admin/documentTypes`,
				method: "POST",
				data: documentType,
			},
		},
	};
}

export function adminPatchDocumentType(documentType) {
	return {
		type: API_ADMIN_PATCH_DOCUMENT_TYPE,
		payload: {
			request: {
				url: `/admin/documentTypes/${documentType.id}`,
				method: "PATCH",
				data: documentType,
			},
		},
	};
}

export function adminDeleteDocumentType(documentType) {
	return {
		type: API_ADMIN_DELETE_DOCUMENT_TYPE,
		payload: {
			request: {
				url: `/admin/documentTypes/${documentType.id}`,
				method: "DELETE",
			},
		},
	};
}

export function initNewDocumentType() {
	return {
		type: ADMIN_INIT_NEW_DOCUMENT_TYPE,
	};
}

export function resetFocusDocumentType() {
	return {
		type: ADMIN_RESET_FOCUS_DOCUMENT_TYPE,
	};
}
